(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(() => {
  const focusResponse = (scope = document) => {
    const response = scope.querySelector('.newsletter-form [data-newsletter-response]');
    if (!response || response.dataset.focused) return;
    response.dataset.focused = 'true';
    // Keep another form's correction focus, or a control the visitor has reached.
    if (document.querySelector('[data-contact-errors]') ||
        (document.activeElement !== document.body && document.activeElement !== document.documentElement)) return;
    response.focus();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => focusResponse(), { once: true });
  } else {
    focusResponse();
  }
  document.addEventListener('shopify:section:load', (event) => focusResponse(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
(() => {
  const fillInterest = (scope = document) => {
    const errors = scope.querySelector('[data-contact-errors]');
    if (errors && !errors.dataset.focused) {
      errors.dataset.focused = 'true';
      errors.focus();
    }
    const field = scope.querySelector('[data-contact-interest]');
    if (!field || field.value) return;
    const interest = new URLSearchParams(window.location.search).get('interest');
    if (interest === null) return;
    field.value = interest.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, field.maxLength);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fillInterest(), { once: true });
  } else {
    fillInterest();
  }
  document.addEventListener('shopify:section:load', (event) => fillInterest(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
